import { useMapEvent, useOverlays } from '@/features/map';
import { useRef } from 'react';
import { TERRAIN_SOURCE } from './terrainStyle';

/**
 * MapLibre places markers and popups using the terrain height known at that moment and only re-places
 * them when the camera moves. One added before the elevation tiles under it have loaded sits at sea
 * level, visibly off its spot in 3D until the map is dragged, so re-place them as elevation data arrives.
 */
export function useOverlayRefreshOnTerrain() {
  const overlays = useOverlays();
  const queued = useRef(false);

  useMapEvent('sourcedata', (e) => {
    if (e.sourceId !== TERRAIN_SOURCE || !e.tile || !e.target.getTerrain() || queued.current) return;
    queued.current = true;
    requestAnimationFrame(() => {
      queued.current = false;
      overlays.refreshAll();
    });
  });
}
